import React from "react";
import { NavLink } from "react-router-dom";
import { Compass, ShoppingBag, User, Boxes, Library } from "lucide-react";

/**
 * AppBottomNav — thumb-friendly tab bar for the PWA.
 * Items vary slightly depending on whether the user is buyer/seller.
 */
const itemBase =
    "flex flex-1 flex-col items-center justify-center gap-1 py-2 text-[10px] font-semibold uppercase tracking-wider transition-colors";

function navClass({ isActive }) {
    return `${itemBase} ${isActive ? "text-md-primary" : "text-md-text-2 hover:text-md-text"}`;
}

export function AppBottomNav({ user, testId }) {
    const isSeller = (user?.roles || []).includes("seller");
    return (
        <nav
            data-testid={testId || "app-bottom-nav"}
            className="sticky bottom-0 z-30 border-t border-md-border bg-md-surface/90 backdrop-blur-md pb-[max(env(safe-area-inset-bottom),0px)]"
            aria-label="Navigation principale"
        >
            <div className="mx-auto flex max-w-md">
                <NavLink to="/app" end className={navClass} data-testid="bottom-nav-home">
                    <Compass className="h-5 w-5" />
                    <span>Aventure</span>
                </NavLink>
                <NavLink to="/app/explorer" className={navClass} data-testid="bottom-nav-explorer">
                    <Library className="h-5 w-5" />
                    <span>Explorer</span>
                </NavLink>
                <NavLink to="/app/missions" className={navClass} data-testid="bottom-nav-missions">
                    <ShoppingBag className="h-5 w-5" />
                    <span>Missions</span>
                </NavLink>
                {isSeller && (
                    <NavLink to="/app/stack" className={navClass} data-testid="bottom-nav-stack">
                        <Boxes className="h-5 w-5" />
                        <span>Doubles</span>
                    </NavLink>
                )}
                <NavLink to="/app/profil" className={navClass} data-testid="bottom-nav-profile">
                    <User className="h-5 w-5" />
                    <span>Profil</span>
                </NavLink>
            </div>
        </nav>
    );
}

export default AppBottomNav;
